var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPointerSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-pointer-solid 1",
    clipPath: "url(#clip0_2037_1639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 2.55898V14.1465C0.5 14.5277 0.809375 14.834 1.1875 14.834C1.38437 14.834 1.575 14.7496 1.70625 14.5996L4.2875 11.6465L6.10313 15.2809C6.35 15.7746 6.95 15.9746 7.44375 15.7277C7.9375 15.4809 8.1375 14.8809 7.89062 14.3871L6.11875 10.834H9.80937C10.1906 10.834 10.5 10.5246 10.5 10.1434C10.5 9.94648 10.4156 9.75898 10.2688 9.62773L1.70625 2.01836C1.57187 1.89961 1.40313 1.83398 1.225 1.83398C0.825 1.83398 0.5 2.15898 0.5 2.55898Z",
    fill: "#99A0A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_1639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.833984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointerSolid);
export default __webpack_public_path__ + "static/media/arrow-pointer-solid.8f439fc4e7538cdc937b5aa7d57b0efc.svg";
export { ForwardRef as ReactComponent };